import MapHelper from "../../utils/helper";
export default class SatelliteViewControl{
    constructor(props){
        this.theme = props.theme;
        this.isSatelliteViewActive = props.isDefaultSattelite;
        this.title = props.title;
    }
    onAdd(map){
        this._map = map;
        this._container = document.createElement("div");
        this._container.className = 'trimblemaps-ctrl trimblemaps-ctrl-group satellite';

        const control = document.createElement('button');
        control.className = 'trimblemaps-ctrl-icon icon-satellite';
        control.title="Map/Satellite View";
        control.ariaLabel="Map/Satellite View";
        control.textContent = '';
        control.addEventListener("click", ()=>{
        if(!this.isSatelliteViewActive){
            this.isSatelliteViewActive = true;
            this._map.setStyle(MapHelper.getMapStyle("satellite"));
        }else{
            this.isSatelliteViewActive =false;
            this._map.setStyle(MapHelper.getMapStyle(this.theme));
        }
        });
       
        this._container.append(control);
        return this._container;
    }
    onRemove() {
        this._container.parentNode.removeChild(this._container);
        this._map = undefined;
    }
}